import React, { useState } from "react";

import "./index.scss";
import Signdesk_logo from "assets/images/signdesk_logo.svg";
import { useLocation, useParams } from "react-router-dom";
import { getWorkflowData } from "api/formDisplay";
import { useEffect } from "react";
import { Button, Row, Container,Col,Image, Navbar } from "react-bootstrap";
// import { AiFillCheckCircle, AiFillCloseCircle } from "react-icons/ai";
import tick from "assets/images/Group 2010.svg";
import failedTick from "assets/images/cross.jpg";
import LoadingSpinner from "lib/LoadingSpinner";
import { useSelector,useDispatch } from "react-redux";
import { getOrgInfo } from "api/organisation";
import { useNavigate } from "react-router-dom";
import{storeOrganisationIdReducer} from "redux/loggedInUserInfo"
import { setAppColor } from "helper";
import{fetchSuccessPageContent} from "api/dashboardDetail"
import{setSuccessPageContent} from "redux/popupReducer"
import { decrypt } from "helper/encryptDecrypt";
const SuccessPage = () => {
  const userParams = useParams();
  const  {state}  = useLocation();
  const [currentStatus, setcurrentStatus] = useState("");
  const [currentUserName, setcurrentUserName] = useState("");
  const [poweredBy, setPoweredBy] = useState(false);
  const [isCreateWorkFlowLoading, setIsCreateWorkFlowLoading] = useState(false);
  const decryptedId = useSelector((state) => state?.urlEncryption?.urlId);
  const configData = useSelector((state) => state.configurationReducer?.config);
  const successPageContent = useSelector((state) => state?.popupReducer?.successPageContent);
  const stateData = JSON.parse(sessionStorage.getItem("stateData"));
  const [decryptData,setdecryptedData]= useState("")
  const [apiResponseFailed,setApiResponseFailed]= useState(false)

  const organisation_id = useSelector(
    (state) => state?.loggedInUserInfo
    ).organisation_id;
    let [logoUrl, setLogoURL] = useState();
    useEffect( () => {
      if(configData?.logo){
        setLogoURL('https://signdesk.in/company/' + configData?.logo)
        const list = document.getElementById('favicon_customized');
        list.href = configData?.icon ? `https://signdesk.in/company/${configData?.icon}` : 'https://signdesk.com/images/favicon.png';
        const titleName = document.getElementById('title-id');
        titleName.innerText =configData?.parent_client_name || "loading...";
      }else{
        getOrgInfo({ _id: organisation_id ? organisation_id :decryptData?.organisation_id }).then((res) => {
          setPoweredBy(res?.white_labeled ? res?.white_labeled : false);
          if (res?.logo) {
            setLogoURL('https://signdesk.in/company/' + res?.logo)
            const list = document.getElementById('favicon_customized');
            list.href = res?.icon ? `https://signdesk.in/company/${res?.icon}` : 'https://signdesk.com/images/favicon.png';
            // list.href = '/unified/' + (res?.fav_icon ? res?.fav_icon : 'signdesk_logo@2x.png');
            const titleName = document.getElementById('title-id');
            titleName.innerText = res?.setting?.parent_client_name;
          } else {
            // setLogoURL("https://signdesk.in/company/signDesk-logo.png")
            // const list = document.getElementById('favicon_customized');
            // list.href = '/unified/signdesk_logo@2x.png';
            // const titleName = document.getElementById('title-id');
            // titleName.innerText = 'Signdesk';
            // setIsCreateWorkFlowLoading(true)
          }
        })
      }
    }, [organisation_id,decryptedId,decryptData])
  const search = window.location.search;
  const query = new URLSearchParams(search);
  const queryPath = query.get("physical_form");
  const dispatch = useDispatch()
  const tickIcon = `<svg class="text-theme" fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="90.818" height="90.818" viewBox="0 0 90.818 90.818">
  <g id="Group_2010" data-name="Group 2010" transform="translate(0 0)">
    <path id="Path_947" data-name="Path 947" d="M173.079,304.959A45.409,45.409,0,1,1,127.67,259.55a45.409,45.409,0,0,1,45.409,45.409Z" transform="translate(-82.261 -259.55)"  opacity="0.1"/>
    <path id="Path_948" data-name="Path 948" d="M156.01,301.639a31.658,31.658,0,1,1-31.657-31.657A31.658,31.658,0,0,1,156.01,301.639Z" transform="translate(-78.77 -256.057)" />
    <path id="Path_949" data-name="Path 949" d="M105.928,296.713l8.854,8.854,21.9-21.9a1.32,1.32,0,0,1,1.863,0l1.4,1.4a1.316,1.316,0,0,1,0,1.863L117.111,309.76l-1.4,1.4a1.317,1.317,0,0,1-1.425.289h0a1.311,1.311,0,0,1-.437-.287l-1.4-1.4-9.786-9.785a1.319,1.319,0,0,1,0-1.865l1.4-1.4a1.318,1.318,0,0,1,1.862,0Z" transform="translate(-75.825 -251.948)" fill="#fff"/>
  </g>
</svg>`
const layoutSetting = useSelector((state)=> state?.loggedInUserInfo?.userAuthInfo?.organisationInfo?.layout_setting)
setAppColor(layoutSetting)

const trigger = React.useMemo(()=>{
  return query.get("trigger")
},[search,query])

useEffect(()=>{
  const getDecryptData = async() =>{
    if(stateData){
    let response = await decrypt(stateData)
    if(response){
      setdecryptedData(response)
    }
  }
}
  getDecryptData()
  },[])

  useEffect(() => {
    window.history.pushState(null, "", window.location.href);
    window.onpopstate = function () {
      window.history.pushState(null, "", window.location.href);
    };
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      if (decryptedId?.subWfId) {
        setIsCreateWorkFlowLoading(true);
        let response = await getWorkflowData(decryptedId?.subWfId);
        if (response) {
          dispatch(storeOrganisationIdReducer({organisation_id:response?.organisation_id}))
          let currentStatus = response.status;
          let currentUserName = response.source_data.full_name ? response.source_data.full_name : "User";

          setcurrentStatus(currentStatus);
          setcurrentUserName(currentUserName);
          // console.log(currentUserName);
          setIsCreateWorkFlowLoading(false);
        }
      }
    };
    if (decryptedId?.subWfId) {
      fetchData();
    }
  }, [decryptedId]);

  useEffect(() => {
    const fetchData = async() =>{
    if(decryptData?.content_trigger?.trigger || trigger){
      let params = {
        organisation_id: decryptData?.organisation_id ? decryptData?.organisation_id : organisation_id,
        trigger: decryptData?.content_trigger?.trigger ? decryptData?.content_trigger?.trigger : trigger,
        subWfID:decryptedId && decryptedId?.subWfId
      };     
      setIsCreateWorkFlowLoading(true)       
      let response = await fetchSuccessPageContent(params)
      if(response?.status == "Success"){
        dispatch(setSuccessPageContent(response?.data))
        setIsCreateWorkFlowLoading(false)     
      }else{
        setApiResponseFailed(true)
        setIsCreateWorkFlowLoading(false)     
      } 
  }
}
fetchData()
},[decryptedId?.subWfId,trigger,organisation_id, decryptData]);



  const getBgColor =
    currentStatus === "Awaiting RM approval" ? "bg-purple" : "bg-blue";
  const color = currentStatus === "in draft" ? "bg-orange" : getBgColor;

  // !document.referrer.includes("update-successful") && window.location.replace(document.referrer);
  const loggedInUserInfo = useSelector(
    (state) => state.loggedInUserInfo?.userAuthInfo
  );
  let loggedUserId = loggedInUserInfo?.profileInfo?.userId || null;
  let navigate = useNavigate();
  const primaryUser = useSelector((state) => state.userInfo?.primaryUser);

  // console.log(queryPath);

  const  windowClose= () => {
    
    let path = "/app/kotak-difc";
    if (loggedUserId) {
      // path = "/dashboard-listing";
     // window.open("_self", "");
      window.close();
      return;
    }
    navigate(path);
  };

  const physicalFormRedirect = () => {
    let path = "/dashboard-listing";
    if (queryPath) {
      window.close();
      return;
    }
    navigate(path);
  };

  
  
  if (isCreateWorkFlowLoading) {
    return <LoadingSpinner />;
  }

  return (

    
      <>
      {successPageContent  ?  
          <div className="bg-forms-two vh-100 bg-no-repeat bg-cover position-relative">
          <Navbar expand="lg" className="bg-body-tertiary bg-mobile bg-forms-two bg-cover">
                  <Container fluid>
                      <Navbar.Brand href="#home">
                          <Image src={logoUrl} className="client-logo" />
                      </Navbar.Brand>
                  </Container>
              </Navbar>

              <Container>
                  <Row className="error-container-height align-items-center justify-content-center">
              <Col xs={12} md={6} lg={4}>
                <div className="p-3 bg-white rounded-3 text-center">
                  <span dangerouslySetInnerHTML={{__html:successPageContent}}></span>
                </div>
              </Col>     
          </Row>
        </Container>
        {poweredBy && (
          <div className="signdesk_logo mb-1 d-lg-block d-md-block d-sm-none d-xs-none bottom-0 d-flex end-0 position-absolute pe-2 p-4">
            <span className="d-flex"><p>Powered by</p><Image src={Signdesk_logo} alt="signDesk_logo" /></span>
          </div>
        )}
      </div> 
      : 
       <div className="bg-forms-two vh-100 bg-no-repeat bg-cover position-relative">
      <Navbar expand="lg" className="bg-body-tertiary bg-mobile bg-forms-two bg-cover">
              <Container fluid>
                  <Navbar.Brand href="#home">
                      <Image src={logoUrl} className="client-logo" />
                  </Navbar.Brand>
              </Container>
          </Navbar>

          <Container>
              <Row className="error-container-height align-items-center justify-content-center">
          <Col xs={12} md={6} lg={4}>
            <div className="p-3 bg-white rounded-3 text-center">
            {/* {<Image src={tick} />} */}
            <span dangerouslySetInnerHTML={{__html:tickIcon}}></span>
            <p className="m-0 fs-20px fw-bold text-theme py-3 py-lg-4">
              {decryptData?.content_trigger?.header ? decryptData?.content_trigger?.header :"Application Submitted Successfully"}
            </p>
            <p className="m-0 fw-bold pb-3 pb-lg-4">
            {decryptData?.content_trigger?.content ? decryptData?.content_trigger?.content :"You will be notified upon successful completion of your journey. Please contact your POC for any questions."}
            </p>
            {decryptData?.content_trigger?.button &&

            <Button
              size=""
              className="bg-primary-dark w-75"
              onClick={()=> window.close()}              >
              {decryptData?.content_trigger?.button}
            </Button>
}
              </div>
          </Col>     
      </Row>
    </Container>
    {poweredBy && (
      <div className="signdesk_logo mb-1 d-lg-block d-md-block d-sm-none d-xs-none bottom-0 d-flex end-0 position-absolute pe-2 p-4">
        <span className="d-flex"><p>Powered by</p><Image src={Signdesk_logo} alt="signDesk_logo" /></span>
      </div>
    )}
  </div>
 
}
    </>
  );
};

export default SuccessPage;

